import PropTypes from "prop-types";
import React, { useEffect, useRef } from "react";

// //Import Scrollbar
import SimpleBar from "simplebar-react";

// MetisMenu
import MetisMenu from "metismenujs";
import { Link, useLocation } from "react-router-dom";
import withRouter from "../Common/withRouter";
import { useSelector } from "react-redux";
import { selectRole, selectUser } from "../../store/auth/selectors";
import { isPortalUserActionRequired } from "../../helpers/userStatusHelper";
//i18n
import { withTranslation } from "react-i18next";
import { useCallback } from "react";

const SidebarContent = (props) => {
  const ref = useRef();
  const path = useLocation();
  const role = useSelector(selectRole);
  const user = useSelector(selectUser);
  const actionRequired = isPortalUserActionRequired(role, user);

  const activateParentDropdown = useCallback((item) => {
    item.classList.add("active");
    const parent = item.parentElement;
    const parent2El = parent.childNodes[1];
    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show");
    }

    if (parent) {
      parent.classList.add("mm-active");
      const parent2 = parent.parentElement;

      if (parent2) {
        parent2.classList.add("mm-show"); // ul tag

        const parent3 = parent2.parentElement; // li tag

        if (parent3) {
          parent3.classList.add("mm-active"); // li
          parent3.childNodes[0].classList.add("mm-active"); //a
          const parent4 = parent3.parentElement; // ul
          if (parent4) {
            parent4.classList.add("mm-show"); // ul
            const parent5 = parent4.parentElement;
            if (parent5) {
              parent5.classList.add("mm-show"); // li
              parent5.childNodes[0].classList.add("mm-active"); // a tag
            }
          }
        }
      }
      scrollElement(item);
      return false;
    }
    scrollElement(item);
    return false;
  }, []);

  const removeActivation = (items) => {
    for (var i = 0; i < items.length; ++i) {
      var item = items[i];
      const parent = items[i].parentElement;

      if (item && item.classList.contains("active")) {
        item.classList.remove("active");
      }
      if (parent) {
        const parent2El =
          parent.childNodes && parent.childNodes.lenght && parent.childNodes[1]
            ? parent.childNodes[1]
            : null;
        if (parent2El && parent2El.id !== "side-menu") {
          parent2El.classList.remove("mm-show");
        }

        parent.classList.remove("mm-active");
        const parent2 = parent.parentElement;

        if (parent2) {
          parent2.classList.remove("mm-show");

          const parent3 = parent2.parentElement;
          if (parent3) {
            parent3.classList.remove("mm-active"); // li
            parent3.childNodes[0].classList.remove("mm-active");

            const parent4 = parent3.parentElement; // ul
            if (parent4) {
              parent4.classList.remove("mm-show"); // ul
              const parent5 = parent4.parentElement;
              if (parent5) {
                parent5.classList.remove("mm-show"); // li
                parent5.childNodes[0].classList.remove("mm-active"); // a tag
              }
            }
          }
        }
      }
    }
  };

  const activeMenu = useCallback(() => {
    const pathName = path.pathname;
    const search = path.search || "";
    let matchingMenuItem = null;
    const ul = document.getElementById("side-menu");
    if (!ul) return;
    const items = ul.getElementsByTagName("a");
    removeActivation(items);

    // First, try exact match including query params
    for (let i = 0; i < items.length; ++i) {
      // Skip dropdown toggles (items with href starting with #)
      if (items[i].href && items[i].href.includes("#")) {
        continue;
      }

      const itemPath = items[i].pathname;
      const itemSearch = items[i].search || "";

      // Check if pathname matches
      if (pathName === itemPath) {
        // If both have query params, check if they match
        if (search && itemSearch) {
          const currentParams = new URLSearchParams(search);
          const itemParams = new URLSearchParams(itemSearch);

          // Check if all query params in current URL match item URL
          let allParamsMatch = true;
          for (const [key, value] of currentParams) {
            if (itemParams.get(key) !== value) {
              allParamsMatch = false;
              break;
            }
          }

          if (allParamsMatch) {
            matchingMenuItem = items[i];
            break;
          }
        } else if (!search && !itemSearch) {
          // Both have no query params, exact match
          matchingMenuItem = items[i];
          break;
        } else if (search && !itemSearch) {
          // Current has query params but item doesn't - prefer item without params if no better match
          if (!matchingMenuItem) {
            matchingMenuItem = items[i];
          }
        }
        // If item has query params but current doesn't, skip (we want exact match)
      }
    }

    // If no exact match and we're on sub-admin-list, ensure Users menu is not active
    if (pathName === "/sub-admin-list") {
      // Ensure Users dropdown is collapsed
      const usersMenu = document.getElementById("usersMenu");
      if (usersMenu) {
        usersMenu.classList.remove("mm-show");
        const usersParent = usersMenu.closest("li");
        if (usersParent) {
          usersParent.classList.remove("mm-active");
          const usersLink = usersParent.querySelector("a.has-arrow");
          if (usersLink) {
            usersLink.classList.remove("mm-active");
          }
        }
      }
    }

    if (matchingMenuItem) {
      activateParentDropdown(matchingMenuItem);
    }
  }, [path.pathname, path.search, activateParentDropdown]);

  useEffect(() => {
    ref.current.recalculate();
  }, []);

  // useEffect(() => {
  //   new MetisMenu("#side-menu");
  //   activeMenu();
  // }, []);
  useEffect(() => {
    const metisMenu = new MetisMenu("#side-menu");
    activeMenu();

    // Cleanup on component unmount
    return () => {
      metisMenu.dispose();
    };
  }, []);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    activeMenu();
  }, [activeMenu]);

  function scrollElement(item) {
    if (item) {
      const currentPosition = item.offsetTop;
      if (currentPosition > window.innerHeight) {
        ref.current.getScrollElement().scrollTop = currentPosition - 300;
      }
    }
  }

  if (role == "admin" || role == "subAdmin") {
    return (
      <React.Fragment>
        <SimpleBar className="h-100" ref={ref}>
          <div id="sidebar-menu">
            <ul className="metismenu list-unstyled" id="side-menu">
              <li>
                <Link to="/dashboard">
                  <i className="bx bx-home-circle"></i>
                  <span>{props.t("Dashboards")}</span>
                </Link>
              </li>

              <li>
                <a href="#usersMenu" className="has-arrow">
                  <i className="bx bx-user"></i>
                  <span>{props.t("Users")}</span>
                </a>
                <ul className="sub-menu" aria-expanded="false" id="usersMenu">
                  <li>
                    <Link to="/user/list">{props.t("All Users")}</Link>
                  </li>
                  <li>
                    <Link to="/user/list?updated=true">
                      {props.t("Profile Update Requests")}
                    </Link>
                  </li>
                </ul>
              </li>
              {role == "admin" && (
                <li>
                  <Link to="/sub-admin-list" className="">
                    <i className="bx bx-user-circle"></i>
                    <span>{props.t("Internal")}</span>
                  </Link>
                </li>
              )}
              <li>
                <Link to="/news-letter-all" className="">
                  <i className="bx bx-news"></i>
                  <span>{props.t("News Letter")}</span>
                </Link>
              </li>
              <li>
                <Link to="/sector/sector-list" className="">
                  <i className="bx bx-collection"></i>
                  <span>{props.t("Sectors & Roles")}</span>
                </Link>
              </li>
              <li>
                <Link to="/contact-us-list" className="">
                  <i className="bx bx-envelope "></i>
                  <span>{props.t("Contact Us List")}</span>
                </Link>
              </li>
              <li>
                <Link to="/cert-list" className="">
                  <i className="bx bx-badge-check"></i>
                  <span>{props.t("Certificates")}</span>
                </Link>
              </li>
              <li>
                <Link to="/courses/list" className="">
                  <i className="bx bx-book"></i>
                  <span>{props.t("Courses")}</span>
                </Link>
              </li>
              {role == "admin" && (
                <li>
                  <Link to="/discounts/list" className="">
                    <i className="bx bx-purchase-tag-alt"></i>
                    <span>{props.t("Discounts")}</span>
                  </Link>
                </li>
              )}
              <li>
                <Link to="/booking/list" className="">
                  <i className="bx bx-book"></i>
                  <span>{props.t("Booking")}</span>
                </Link>
              </li>
              {/* <li>
                <Link to="/pending-confirmation" className="">
                  <i className="bx bx-time-five"></i>
                  <span>{props.t("Pending Confirmation")}</span>
                </Link>
              </li>
              <li>
                <Link to="/leave-requests" className="">
                  <i className="bx bx-calendar-minus"></i>
                  <span>{props.t("Leave Requests")}</span>
                </Link>
              </li> */}
              {/* Upskilling admin reviews — temporarily disabled
              <li>
                <Link to="/upskilling-admin" className="">
                  <i className="bx bx-task"></i>
                  <span>
                    {props.t("Upskilling reviews", "Upskilling reviews")}
                  </span>
                </Link>
              </li>
              */}
              {/* <li>
                <Link to="/refund-requests" className="">
                  <i className="bx bx-transfer-alt"></i>
                  <span>{props.t("Refund requests")}</span>
                </Link>
              </li>
              <li>
                <Link to="/audit-logs" className="">
                  <i className="bx bx-history"></i>
                  <span>{props.t("Audit Logs")}</span>
                </Link>
              </li> */}
              {role == "subAdmin" && (
                <li>
                  <Link to="/user/me" className="">
                    <i className="bx bx-user "></i>
                    <span>{props.t("profileLabel", "Profile")}</span>
                  </Link>
                </li>
              )}
            </ul>
          </div>
        </SimpleBar>
      </React.Fragment>
    );
  } else if (role == "client") {
    return (
      <React.Fragment>
        <SimpleBar className="h-100" ref={ref}>
          <div id="sidebar-menu">
            <ul className="metismenu list-unstyled" id="side-menu">
              <li>
                <Link to="/dashboard" className="">
                  <i className="bx bx-home-circle"></i>
                  <span>{props.t("clientMenuDashboard", "Dashboard")}</span>
                </Link>
              </li>
              {!actionRequired && (
                <>
                  <li>
                    <Link to="/create-booking" className="">
                      <i className="bx bx-user-plus"></i>
                      <span>
                        {props.t("clientMenuRequestStaff", "Request Staff")}
                      </span>
                    </Link>
                  </li>
                  <li>
                    <Link to="/client/bookings" className="">
                      <i className="bx bx-book"></i>
                      <span>
                        {props.t("clientMenuMyBookings", "My Bookings")}
                      </span>
                    </Link>
                  </li>
                  <li>
                    <Link to="/client/role-rate-cards" className="">
                      <i className="bx bx-purchase-tag-alt"></i>
                      <span>
                        {props.t(
                          "clientMenuRoleRateCards",
                          "Role & Rate Cards"
                        )}
                      </span>
                    </Link>
                  </li>
                  <li>
                    <Link to="/client/commercial-documents" className="">
                      <i className="bx bx-file"></i>
                      <span>
                        {props.t(
                          "clientMenuCommercialDocuments",
                          "Commercial Documents"
                        )}
                      </span>
                    </Link>
                  </li>
                </>
              )}
              <li>
                <Link to="/contact-us" className="">
                  <i className="bx bx-envelope"></i>
                  <span>
                    {props.t("clientMenuContactJobark", "Contact JobArk")}
                  </span>
                </Link>
              </li>
            </ul>
          </div>
        </SimpleBar>
      </React.Fragment>
    );
  } else if (role == "worker") {
    return (
      <React.Fragment>
        <SimpleBar className="h-100" ref={ref}>
          <div id="sidebar-menu">
            <ul className="metismenu list-unstyled" id="side-menu">
              <li>
                <Link to="/dashboard" className="">
                  <i className="bx bx-home-circle"></i>
                  <span>{props.t("workerMenuDashboard", "Dashboard")}</span>
                </Link>
              </li>
              {!actionRequired && (
                <>
                  <li>
                    <Link to="/my-assignments" className="">
                      <i className="bx bx-book"></i>
                      <span>
                        {props.t("workerMenuMyAssignments", "My Assignments")}
                      </span>
                    </Link>
                  </li>
                  <li>
                    <Link to="/worker-leave-requests" className="">
                      <i className="bx bx-calendar-check"></i>
                      <span>
                        {props.t(
                          "workerMenuAttendanceTimesheets",
                          "My Attendance & Timesheets"
                        )}
                      </span>
                    </Link>
                  </li>
                  <li>
                    <Link to="/worker/role-rate-cards" className="">
                      <i className="bx bx-purchase-tag-alt"></i>
                      <span>
                        {props.t(
                          "workerMenuRoleRateCards",
                          "Role & Rate Cards"
                        )}
                      </span>
                    </Link>
                  </li>
                </>
              )}
              <li>
                <Link to="/upskilling" className="">
                  <i className="bx bx-trending-up"></i>
                  <span>{props.t("workerMenuUpskilling", "Upskilling")}</span>
                </Link>
              </li>
              <li>
                <Link to="/contact-us" className="">
                  <i className="bx bx-envelope "></i>
                  <span>
                    {props.t("workerMenuContactJobark", "Contact Jobark")}
                  </span>
                </Link>
              </li>
            </ul>
          </div>
        </SimpleBar>
      </React.Fragment>
    );
  }
};

SidebarContent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any
};

export default withRouter(withTranslation()(SidebarContent));
